module.exports = __webpack_public_path__ + "static/media/help-img2.a3c43ea8.png";